import React from 'react'

import Box from 'components_new/atoms/Box'
import Skeleton from 'components_new/atoms/Skeleton'

const Loading = () => {
  return (
    <>
      <Box
        sx={{
          width: '100%',
          height: 'calc(100% - 20px)',
          p: 2
        }}
      >
        <Skeleton variant="rounded" height={'100%'} sx={{ flex: 1 }} />
      </Box>
    </>
  )
}

export default Loading
